import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-table',
  templateUrl: './company-table.component.html',
  styleUrls: ['./company-table.component.scss']
})
export class CompanyTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
